import { UserDefinitionSelectItem } from "./UserDefinitionSelectItem";
import { InstitutionItem } from "../../../../domain/institution/InstitutionItem";

export class UserDefinitionSelectResult {
  items: UserDefinitionSelectItem[];
  isBlank: boolean = false;
  institution: InstitutionItem;
}
